import { render, staticRenderFns } from "./TimePeriodTypeAutocomplete.vue?vue&type=template&id=c38b3c06&scoped=true&"
import script from "./TimePeriodTypeAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./TimePeriodTypeAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38b3c06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
